<template>
    <!-- <div :class="['componentContainer', { single: testImages.length == 1, multiple: testImages.length > 1 }]"> -->
    <div class='componentContainer single'>
        <div class="image-layout d-flex justify-content-center align-content-center">
            <span v-if="loading" class="m-auto position-absolute spinner-border top-50"></span>
            <img class="lozad" width="236" height="236" :src="`${base_url}/assets/image/logo.png`" :data-src="imageSrc" alt=""
                v-if="imageLength == 1" @load="onImageLoad" @click="() => toggleModal(0, imageSrc)" />
        </div>
        <!-- <div class="imageContainer" v-if="testImages.length == 2">
                    <img @click="() => toggleModal(index, image)" v-for="(image, index) in testImages" :key="image" :src="image"
                        height="118" width="118" />
                </div>
<div class="imageContainer" v-if="testImages.length > 2">
                <div class="countContainer">
                    <img @click="() => toggleModal(1, testImages[1])" :src="testImages[1]" height="118" width="118" />
                    <span class="count">{{ testImages.length - 1 }}+</span>
                </div>
                <img @click="() => toggleModal(0, testImages[0])" :src="testImages[0]" height="118" width="118" />
            </div> -->
    </div>
    <div class="messageContent" v-if="message.content.image.caption">{{ message.content.image.caption }}</div>
    <ImagePreview @update:isModalOpen="toggleModal" :personName="message.profile_name ?? ''" :time="''"
        :currentImage="selectedImage" :images="[imageSrc]" :currentIndex="selectedImageIndex" :isModalOpen="isModalOpen" />
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import ImagePreview from "@/components/whatsapp-managment/includes/types/ImagePreview.vue"
import lozad from 'lozad'

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

const imageSrc = ref('')
const isModalOpen = ref(false)
const selectedImage = ref('')
const selectedImageIndex = ref(-1)
const toggleModal = (index = -1, image = '') => {
    selectedImage.value = image
    selectedImageIndex.value = index
    isModalOpen.value = !isModalOpen.value
}

onMounted(() => {
    imageSrc.value = props.message.content.image.url
    const observer = lozad('.lozad', {
        rootMargin: '10px 0px',
        threshold: 0.1,
        enableAutoReload: true
    });
    observer.observe();
    const base_url = window.location.origin;

})
// loading
const loading = ref(true);

const onImageLoad = () => {
    loading.value = false;
};
const imageLength = computed(() => {
    if (!props.message)
        return 0;
    // calc length image
    // return props.message.content.url;
    return 1;
})
</script>

<style scoped lang="scss">
@import './styles/images.scss';
</style>
